import { Injectable } from "@angular/core";
import { CoreService } from "../../../base/core";
import { ServiceRoute } from "../../../base/service-route";
import { CommonHttpOption } from "../../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SubsidiaryContractService {
  constructor(private coreService: CoreService) { }
  // get contract
  getContract(params:any,pageIndex: number = 0, pageSize: number = 0): Observable<any> {
    console.log(params);

    return this.coreService.get(
      ServiceRoute.subsidiary.dashboard.contract.getUserAgentList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize)

    );
  }

  getCustomerContractPersonAddState(params: any): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.contract.GetCustomerContractPersonAddState + params,
      new CommonHttpOption().headers
    );
  }

}
